//--------------
// has bleeders
//--------------
export default function hasBleeders(combatants) {
  //----------------------------------------------
  // where one or more bleeders exist (in/active)
  //----------------------------------------------
  let bleeders = combatants.some((a) => a.bleeding > 0);
  return bleeders;
}
